import { useFormikContext, getIn } from 'formik';
import React, { useState, useEffect, useMemo } from 'react';
import Select from './Selector';
import { Container, Row, Col, Button } from 'reactstrap';
import { useEdit } from '../../Services/EditContext';
import { useFetchCached } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import { FormLabel } from './FormLabel';
import ErrorMessage from './ErrorMessage'
import FormInput from './FormInput';
import CompareFormValue from './CompareFormValue';
import SelectSetting from './SelectSetting';


const CharterType = ({ id, supplier, label, noEdit, placeBid, supplierChange }) => {
    const [edit] = useEdit();
    const [charterTypes, loadingCharterTypes, errorCharter] = useFetchCached(endpoints.getCharterType);
    const { values, setFieldValue } = useFormikContext();
    const { charterType, charterSubType, } = values;
    const value = getIn(values, id);
    const mainTypes = useMemo(() => [{ label: "Passenger Charter", value: 0, dbValue: 'Passenger' },
    { label: "Freight", value: 1, dbValue: 'Freight' },
    { label: "Aerial Work / Aerial Services", value: 2, dbValue: 'Aerial' },
    ], []);
    const [subTypeList, setSubTypeList] = useState();
    const initialType = mainTypes?.find(x => x.dbValue === charterType);
    const [mainType, setMainType] = useState(initialType ? initialType : null);
    const subTypes = subTypeList && mainType ? subTypeList[mainType.value] : [];
    const initialSubType = initialType ? subTypes?.find(x => x.label === charterSubType) : '';
    const [subType, setSubType] = useState(initialSubType ? initialSubType : subTypes ? subTypes[0] : '');

    const [supplierValues, setSupplierValues] = useState([]);

    useEffect(() => {
        if (supplier && value && subTypeList && !supplierValues.length) {
            const allValues = value ? value.split(',') : [];
            const newSupplierValues = mainTypes.map((x) => {
                return subTypeList ? subTypeList[x.value]?.filter((y) => {
                    return allValues.find((z) => {
                        return z === y.value
                    }) ? true : false;
                }) : [];
            })
            setSupplierValues(newSupplierValues);
        }

    }, [value, subTypeList, mainTypes, supplier, supplierValues.length]);


    useEffect(() => {
        if (charterTypes && !subTypeList) {
            const v = [
                charterTypes.passengerCharterTypes?.map(x => { return { label: x.value, value: x.value }; }),
                charterTypes.freightCharterTypes?.map(x => { return { label: x.value, value: x.value }; }),
                charterTypes.aerialCharterTypes?.map(x => { return { label: x.value, value: x.value }; })
            ];
            setSubTypeList(v);
        }
    }, [charterTypes, supplier, mainType, charterSubType, initialType, subTypeList])


    useEffect(() => {
        if (charterTypes && !supplier && !mainType && setFieldValue && !initialType) {
            setFieldValue('charterType', '');

        }

    }, [charterTypes, supplier, mainType, initialType, setFieldValue])


    const mainTypeChanged = (v) => {
        if (!supplier) {
            setMainType(v);
            setFieldValue('charterType', v.dbValue);
            setFieldValue('charterSubType', '');
        }
    };
    const subTypeChanged = (v) => {
        if (!supplier) {
            setSubType(v);
            setFieldValue('charterSubType', v.label);
        }
    };
    const supplierSubTypeChanged = (type, value) => {

        let st = [...supplierValues];
        st[type.value] = value;
        setSupplierValues(st);
    }
    useEffect(() => {
        if (id && supplierValues && supplierValues.length) {
            const v = [];
            supplierValues && supplierValues.map((val) => {
                return val && val.map(w => v.push(w.value));
            });
            const newValue = v.length ? v.join(',') : '';
            if (newValue !== value) {
                supplierValues && setFieldValue(id, newValue);
            }
        }
    }, [supplierValues, id, value, setFieldValue])

    return supplier ? <React.Fragment>
        <FormLabel htmlFor="charterType" style={{ display: 'block' }}>
            {label}
        </FormLabel>
        <Container>
            {edit && !noEdit ? mainTypes.map((type, i) => {
                return <Col key={i}><Row >
                    <FormLabel htmlFor={type.value} style={{ display: 'block' }}>{type.label}</FormLabel>
                    {subTypeList?.length && supplierValues?.length && supplierValues[type.value] && subTypeList[type.value].length !== supplierValues[type.value]?.length && <Button className="link" style={{ position: 'absolute', right: 0 }} onClick={() => supplierSubTypeChanged(type, subTypeList[type.value])}>Select All</Button>}
                </Row>
                    {subTypeList ? <Row>
                        <Select id={type.value} hideAllButton isMulti options={subTypeList[type.value]}
                            value={supplierValues && supplierValues.length ? supplierValues[type.value] : []}
                            onChange={(value) => supplierSubTypeChanged(type, value)} style={{ width: '100%' }} />
                    </Row> : null}

                </Col>
            }) : <Col><i>
                <ul>
                    {supplierValues && supplierValues.length ? supplierValues.map(type =>
                        type ? type.map(v =>
                            <li key={type.value + '_' + v.value}>{v.value}</li>
                        ) : 'No Types'
                    ) : null}
                </ul>
            </i></Col>
            }

            <ErrorMessage name={id} />
        </Container></React.Fragment> :
        <Row>
            <Col md='3' xs='3'>
                {loadingCharterTypes ? "Loading" : ""}
                {errorCharter ? "Error" : ""}
                <FormLabel htmlFor="charterType" style={{ display: 'block' }}>
                    Charter Type
                </FormLabel>
                {edit && !noEdit ? <Select id='charterType' options={mainTypes} value={mainType} onChange={mainTypeChanged} /> : <CompareFormValue id='charterType' />}
                <ErrorMessage name='charterType' />
            </Col>
            <Col md='3' xs='3'>
                <FormLabel htmlFor="charterSubType" style={{ display: 'block' }}>
                    Charter SubType
                </FormLabel>
                {edit && !noEdit ? <Select id="charterSubType" options={subTypes} value={subType} onChange={subTypeChanged} /> : <CompareFormValue id='charterSubType' />}
                <ErrorMessage name='charterSubType' />
            </Col>
            <Col md='3' xs='3'>
                <SelectSetting noEdit={placeBid || supplierChange} endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
            </Col>
            <Col>
                <FormInput noEdit={noEdit} id='purchaseOrderNumber' label='Purchase Order Number' />
            </Col>
        </Row>
}

export default CharterType;